'use client';

import './AboutUsAnimationBlock.scss';
import cn from 'classnames';
import React, { useState } from 'react';
import { Image } from '@sitecore-jss/sitecore-jss-react';

export default function AboutUsAnimationBlock(data) {
  const [isHover, setIsHover] = useState(data.fields.images?.[0]?.id);

  const handleMouseEnter = (value) => {
    setIsHover(value);
  };

  return (
    <div className={'container about-us-animation-block'}>
      <div className={'wrapper'} data-aos="fade-up">
        {data.fields.images?.map((el) => {
          return (
            <div
              key={el.id}
              className={cn('item', isHover === el.id && 'item_hover')}
              onMouseEnter={() => handleMouseEnter(el.id)}
            >
              <Image alt={el.fields.title.value} field={el.fields.image.fields.desktopImage} />
              <p className={cn('item_text', isHover === el.id && 'item_text_show')}>
                {el.fields.title.value}
              </p>
            </div>
          );
        })}
      </div>
    </div>
  );
}
